<script setup lang="ts">
import MapWithSingleMarker from "@/components/atoms/map/MapWithSingleMarker.vue";
import { formatDateRange } from "@/utils/date";

const props = defineProps({
  stage: {
    type: Object,
    default: () => null
  },
  inlineMap: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
  <div v-if="props.stage">
    <slot :stage-name="props.stage.name" :formatted-date="formatDateRange(props.stage.start_at, props.stage.end_at)">
      <h5>{{ props.stage.name }}</h5>
      <div class="text-muted">{{ formatDateRange(props.stage.start_at, props.stage.end_at) }}</div>
    </slot>
    <template v-if="props.stage.location">
      <slot name="location"
            :location="props.stage.location">
      </slot>
    </template>
    <template v-if="props.stage.quota && props.stage.quota.total != null">
      <slot name="quota"
            :quota="props.stage.quota">
        <div class="mt-3">
          <div>
            <strong class="h5 mr-2">{{ props.stage.quota.remaining }}</strong>
            <span class="text-muted">{{ $t("remaining place", props.stage.quota.remaining) }}</span>
          </div>
          <div class="progress mt-1" style="height: 3px">
            <div class="progress-bar" :style="'width: ' + props.stage.quota.percentage_used + '%'" role="progressbar"
                 :aria-valuenow="props.stage.quota.percentage_used" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </slot>
    </template>
    <template v-if="props.inlineMap">
      <MapWithSingleMarker
        v-if="props.stage.location"
        :position="{
        lat: props.stage.location.latitude,
        lng: props.stage.location.longitude,
      }"
        :zoom="12"
        style="height:200px" class="mt-4"
      >
      </MapWithSingleMarker>
    </template>
  </div>
</template>

<style scoped>

</style>